import { useCustomerId, useURLparams, usePagination } from '@hooks';
import { PaginationMetadata } from '@modules/usersManagment/data/useGetAllUsersPaginated';
import { DispersionReport } from '../constants';

interface pages extends PaginationMetadata {
  page: DispersionReport[];
}
/**
 * Obtains a list of consolidated dispersions
 */
const useConsolidatedDispersionsList = () => {
  const { params, setURLparams } = useURLparams<{
    toDate?: string;
    fromDate?: string;
    limit?: string;
    page?: string;
    customerId?: string;
  }>();
  const { customerId = params?.customerId } = useCustomerId();

  const { data: paginatedData, ...props } = usePagination(
    params.fromDate && params.toDate ? `/v3/dispersion/report/${customerId}` : '',
    {
      params: params,
      setURLparams,
      paramKeys: ['fromDate', 'toDate', 'page', 'limit'],
    }
  );
  const parsedData = paginatedData as pages | undefined;

  return { ...props, data: parsedData };
};
export default useConsolidatedDispersionsList;
